export default __webpack_public_path__ + "static/media/secondPic.f3428555.webp";